import http from "../../http-common";
/* eslint-disable */
class MitraPusdokkesService {
  mitraPusdokkesList(page, itemPerPage, keyword) {
    return http.get(
      "/mitrapusdokkes/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("telp", data.telp);
    bodyFormData.append("fax", data.fax);
    bodyFormData.append("email", data.email);
    bodyFormData.append("alamat", data.alamat);
    bodyFormData.append("website", data.website);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.post("/mitrapusdokkes", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("telp", data.telp);
    bodyFormData.append("fax", data.fax);
    bodyFormData.append("email", data.email);
    bodyFormData.append("alamat", data.alamat);
    bodyFormData.append("website", data.website);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.put(`/mitrapusdokkes/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/mitrapusdokkes/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new MitraPusdokkesService();
